angular.module('execution-deadline')
    .controller('ExecutionDeadlineDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, ExecutionDeadline) {
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = ExecutionDeadline.update(this.item).$promise
            } else {
                promise = ExecutionDeadline.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast("executiondeadline.updated", result)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
